const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.133 18.354v2.445l-1.066 1.067 1.6 1.6-1.6 1.6 1.066 1.068c0 1.067-1.066 2.133-2.133 2.133s-2.134-1.066-2.134-2.133v-7.78a7.467 7.467 0 114.267 0M16 0c8.836 0 16 7.163 16 16s-7.164 16-16 16C7.163 32 0 24.836 0 16 0 7.163 7.163 0 16 0zm0 5.867a2.133 2.133 0 100 4.266 2.133 2.133 0 000-4.266z"
});

const SvgKeypoints = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ec6d4b",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeypoints, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keypoints.7416a8fb.svg";
export { ForwardRef as ReactComponent };